import script from "./StudySpace.vue?vue&type=script&setup=true&lang=js"
export * from "./StudySpace.vue?vue&type=script&setup=true&lang=js"

import "./StudySpace.vue?vue&type=style&index=0&id=56462b98&lang=css"

const __exports__ = script;

export default __exports__